export default "__VITE_ASSET__8c7a4c7d__"